/**
 * accordion script
 */

export const accordion = () => {
	// main area accordion
	const elements = document.querySelectorAll('.element');

	elements.forEach((element) => {
		const btn = element.querySelector('.main-area');
		const icon = element.querySelector('.main-area button i');
		const answer = element.lastElementChild;
		const answers = document.querySelectorAll('.element .links-reveal');

		btn.addEventListener('click', () => {
			answers.forEach((ans) => {
				const ansIcon = ans.parentElement.querySelector('button i');
				if (answer !== ans) {
					ans.classList.add('hideText');
					ansIcon.className = 'top-accordion-open';
				}
			});

			answer.classList.toggle('hideText');
			// eslint-disable-next-line no-unused-expressions
			icon.className === 'top-accordion-open'
				? (icon.className = 'top-accordion-close')
				: (icon.className = 'top-accordion-open');
		});
	});

	// inner accordion
	const pageLinksarea = document.querySelectorAll('.element-inner');

	pageLinksarea.forEach((element) => {
		const btn = element.querySelector('.page-name');
		const icon = element.querySelector('.page-name button i');
		const answer = element.lastElementChild;
		const answers = document.querySelectorAll(
			'.element-inner .page-description'
		);

		if (btn) {
			btn.addEventListener('click', () => {
				answers.forEach((ans) => {
					const ansIcon = ans.parentElement.querySelector('button i');
					if (answer !== ans) {
						ans.classList.add('hideText');
						ansIcon.className = 'page-name-open';
					}
				});

				answer.classList.toggle('hideText');
				// eslint-disable-next-line no-unused-expressions
				icon.className === 'page-name-open'
					? (icon.className = 'page-name-close')
					: (icon.className = 'page-name-open');
			});
		}
	});
};
